import React, { useEffect, useState } from "react";
import Base from '../../utils/base'
import moment from "moment";
import $ from 'jquery'

export default function Tour(props) {
  var base = new Base()
  const momentNow = moment()
  const [homeGallery, setHomeGallery] = useState({})
  const [arrGallery, setArrGallery] = useState([
    // {
    //   id: '',
    //   image: 'assets/images/assets/Building Night.png?rnd=' + momentNow.format('HHmmss'),
    // },
    // {
    //   id: '',
    //   image: 'assets/images/assets/Building.jpg?rnd=' + momentNow.format('HHmmss'),
    // },
    // {
    //   id: '',
    //   image: 'assets/images/assets/Cafe.jpg?rnd=' + momentNow.format('HHmmss'),
    // },
    // {
    //   id: '',
    //   image: 'assets/images/assets/Lobby.jpg?rnd=' + momentNow.format('HHmmss'),
    // },
    // {
    //   id: '',
    //   image: 'assets/images/assets/Reception with Logo.png?rnd=' + momentNow.format('HHmmss'),
    // },
  ])

  useEffect(() => {
    get_data()
    get_info_data()
  }, [])
  
  async function get_data() {
    var response = await base.request(base.url_api + "/home-gallery/all")

    if(response != null){
      if(response.status == "success"){
        for(let data of response.data){
          data.image = data.url_image
        }
        // console.log(response.data)
        setArrGallery(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  async function get_info_data() {
		var response = await base.request(base.url_api + "/info?type=home_gallery&lang=id")

		if(response != null){
			if(response.status == "success"){
				setHomeGallery(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  return (
    <div class="gallery-three " style={{ padding: '120px 0', marginTop: '8.5rem' }}>
      <div class="container">
        <div class="sec-title text-center">

          {/* <img src="assets/images/shapes/sec-title-s-1.png" alt="Promotion" class="sec-title__img" /> */}


          <h6 class="sec-title__tagline bw-split-in-right" style={{ fontSize: '.8rem', }}>{homeGallery.title}</h6>

          <h3 class="sec-title__title bw-split-in-up text-uppercase" style={{ fontSize: '3.125rem', }}>{homeGallery.subtitle}</h3>
        </div>

        <div class="masonry-layout gutter-y-20 gutter-x-20 d-flex justify-content-center align-items-center">
          <script src="https://cdn.lightwidget.com/widgets/lightwidget.js"></script>
          <div style={{ width: '100%', maxWidth: '100%', }} id="lightwidget_container">
            <iframe src="//lightwidget.com/widgets/9135f17f91a85d67b29eedf1bfc963cb.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" id="lightwidget_iframe" style={{ width: '100%', border: '0', overflow: 'scroll', height: '100%', }}></iframe>
          </div>

          {/*
            arrGallery.map((gallery, index) => (
              <div class={index % 2 == 0 ? "col-xl-3 col-lg-3 col-md-6" : "col-xl-6 col-lg-6 col-md-6"}>
                <div class="gallery-three__item">
                  <img src={gallery.image} alt="solinom gallery" style={{ height: '200px', }}/>
                  <div class="gallery-three__item__hover">
                    <a href={gallery.image} target="_blank" class="gallery-three__item__icon">
                      <span class="icon-instagram"></span>
                    </a>
                  </div>
                </div>
              </div>
            ))
          */}
          
        </div>
      </div>
    </div>
  );
};
